/**
 * Adds callback to element's resize observer
 * 
 * @param {ResizeObserverCallback} callback Callback to fire on element's resize
 * @param {Element | null |undefined} target target to observe
 * 
 * @returns {ResizeObserver} ResizeObserver instance or it's interval-based shim
 */
export function attachResizeObserver(callback, target) {
    var observer = getResizeObserver(callback);
    if (target) {
        observer.observe(target);
    }
    return observer;
}


/**
 * Creates new ResizeObserver or it's interval-based shim.
 * 
 * @param {ResizeObserverCallback} callback 
 */
function getResizeObserver(callback) {
    if (typeof ResizeObserver !== 'undefined') {
        return new ResizeObserver(callback);
    }

    console.warn('ResizeObserver interface is unavailable, using shim instead');

    /** @type {[Element, {width: number, height: number}][]} */
    var shimObservedTargets = [];
    var observerObjectInterface = {
        disconnect: function () {
            shimObservedTargets = [];
        },
        observe: function (/** @type {Element | HTMLElement} */ target) {
            shimObservedTargets.push([target, getTargetDimensions(target)]);
        },
        unobserve: function (/** @type {Element} */ target) {
            shimObservedTargets = shimObservedTargets.filter(
                function (arrayItem) {
                    return arrayItem[0] !== target;
                }
            );
        }
    };
    var callbackWrapperFunc = function () {
        shimObservedTargets.forEach(function (arrayItem) {
            if (!arrayItem[0]) {
                return;
            }

            var stored = arrayItem[1];
            var current = getTargetDimensions(arrayItem[0]);

            if (
                stored.width !== current.width
                || stored.height !== current.height
            ) {
                arrayItem[1] = current;
                // Passing no ResizeObserverEntry items in array from shim
                callback([], observerObjectInterface);
            }
        });
    };
    var interval = setInterval(callbackWrapperFunc, 16);
    callbackWrapperFunc();

    return observerObjectInterface;
}

/**
 * Returns element's dimensions (width and height).
 * 
 * @param {Element | HTMLElement | undefined} target Target to get it's size
 * @returns {{width: number, height: number}} Element's dimensions
 */
function getTargetDimensions(target) {
    if (!target) {
        return { width: 0, height: 0 };
    }
    return {
        width: target.offsetWidth ?? target.clientWidth,
        height: target.offsetHeight ?? target.clientHeight,
    }
}
